import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { reactIcons } from "../../utils/icons";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { getAuthReq, postAuthReq, putReq } from "../../utils/apiHandlers";
import toast from "react-hot-toast";
import NotificationBar from "../NotificationBar";
import InfoModal from "../modals/InfoModal";
import moment from "moment/moment";
import { setNotificationUpdate } from "../../redux/Slice/notificationSlice";
import NotificationPanel from "../NotificationPanel";

const Header = ({ toggleSidebar, isVerify }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [NotificationData, setNotificationData] = useState();
  const { userData } = useSelector((state) => state?.user || {});
  const [showNotification, setShownotification] = useState(
    Boolean(Cookies.get(`NotificationShow`)),
  );
  const notificationContainerRef = useRef(null);
  const notificationBellRef = useRef(null);
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const [notificationAll, setNotificationAll] = useState([]);
  const groupedNotifications = {};
  const dispatch = useDispatch();
  const notificationUpdate = useSelector((state) => state.notification.update);
  const [openInfo, setOpenInfo] = useState(false);
  const currentPath = window.location.pathname;
  const getToken =
    sessionStorage.getItem("referredAs") == "User"
      ? Cookies.get("accessToken")
      : Cookies.get("pfaccessToken");
  const token = useSelector((state) => state.user.token);
  const localFCMToken = token !== localStorage.getItem("fcmToken") || "";
  const [messages, setMessages] = useState([]);
  const [update, setUpdate] = useState(false);
  const [currentMessages, setCurrentMessages] = useState([]);
  const getNotification = async () => {
    try {
      const res = await getAuthReq(
        "/notification/all-active-alert-notification",
      );
      const { data, status } = res;
      if (status) {
        const grouped = data.reduce(
          (acc, item) => {
            if (item.display === "BeforeLogin") {
              acc.BeforeLogin.push(item);
            } else if (item.display === "AfterLogin") {
              acc.AfterLogin.push(item);
            }
            return acc;
          },
          { BeforeLogin: [], AfterLogin: [] },
        );
        setNotificationData(grouped);
      } else {
        toast.error(data.message);
      }
    } catch (err) {
      toast.error(err.message);
    }
  };

  useEffect(() => {
    setIsNotificationOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (getToken && notificationUpdate) {
      getOldNotification();
      dispatch(setNotificationUpdate(false));
    }
  }, [notificationUpdate]);

  useEffect(() => {
    if (getToken && userData?.id) {
      getOldNotification();
    }
  }, [getToken, update, userData?.id]);

  const setFirebaseToken = async () => {
    const response = await postAuthReq("/notification/save-token", {
      token: token,
      userId: userData?.id,
    });
    if (!response?.status) {
      localStorage.removeItem("fcmToken");
    }
  };

  useEffect(() => {
    if (getToken && token && localFCMToken) {
      localStorage.setItem("fcmToken", token);
      setFirebaseToken();
    }
  }, [token, getToken]);

  const getOldNotification = useCallback(async () => {
    try {
      const res = await getAuthReq(
        `/notification/get-user-notifications/${userData?.id}`,
      );

      if (res.status) {
        setMessages(res?.data);
        setUpdate(false);
        setNotificationAll(res?.data || []);
      } else {
        toast.error(res.error.message, { toastId: 149 });
      }
    } catch (error) {
      console.error("Error sending wallet address:", error);
    }
  }, [userData?.id, setMessages, setUpdate, setNotificationAll]);

  notificationAll.forEach((item) => {
    const date = moment(item.createdAt);
    const today = moment();
    const yesterday = moment().subtract(1, "days");
    let groupKey = "";
    if (date.isSame(today, "day")) {
      groupKey = "Today";
    } else if (date.isSame(yesterday, "day")) {
      groupKey = "Yesterday";
    } else {
      groupKey = date.format("MMMM D, YYYY");
    }
    if (!groupedNotifications[groupKey]) {
      groupedNotifications[groupKey] = [];
    }

    groupedNotifications[groupKey].push(item);
  });

  useEffect(() => {
    let messageId;
    if (isNotificationOpen && currentMessages.length > 0) {
      const data = {
        ids: messages
          .filter((item) => !item.read)
          .map((item) => item.id || item.notificationId),
      };
      messageId = setTimeout(async () => {
        try {
          const response = await putReq(
            "/notification/change-seen-status",
            data,
          );
          if (response) {
            setCurrentMessages([]);
            getOldNotification();
          }
        } catch (error) {
          toast.error(error?.message || "Something went wrong");
        }
      }, 3000);
    } else return;
    return () => clearTimeout(messageId);
  }, [currentMessages, isNotificationOpen, messages]);

  useEffect(() => {
    getNotification();
  }, []);

  const handleCookiesForShow = () => {
    Cookies.set("NotificationShow", true);
    setTimeout(() => {
      Cookies.remove("NotificationShow");
      setShownotification(Boolean(Cookies.get(`NotificationShow`)));
    }, 1800000);
    setShownotification(Boolean(Cookies.get(`NotificationShow`)));
  };

  useEffect(() => {
    if (messages) {
      const unreadMessage = messages.filter((item) => !item.read);
      setCurrentMessages(unreadMessage);
    }
  }, [messages]);

  return (
    <>
      <NotificationBar
        showNotification={showNotification}
        getToken={getToken}
        NotificationData={NotificationData}
        currentPath={currentPath}
        handleCookiesForShow={handleCookiesForShow}
        reactIcons={reactIcons}
      />
      <div className="portal-header h-[80px] w-full z-[9999] relative">
        <div className="flex h-full items-center justify-between gap-3 px-3 lg:px-6">
          <div
            onClick={() => {
              const cookeiData =
                sessionStorage.getItem("referredAs") == "User"
                  ? Cookies.get("accessToken")
                  : Cookies.get("pfaccessToken");
              if (cookeiData && !isVerify) {
                navigate("/portal/kyc");
              } else if (cookeiData) {
                navigate("/portal/dashboard");
              } else {
                navigate("/portal");
              }
            }}
            className="flex items-center gap-2 cursor-pointer"
          >
            <img
              loading="lazy"
              src="https://ik.imagekit.io/avboeabnm1/images/logo/main.png"
              alt="logo"
              className="w-[44px] md:w-[50px]"
            />
            <div>
              <img
                loading="lazy"
                src="https://ik.imagekit.io/avboeabnm1/images/logo/sad.png"
                alt="logo"
                className="w-[150px] md:w-[170px]"
              />
              <p className="text-[7px] md:text-[8px] text-white/70 mt-1 text-center tracking-wider">
                YOUR PATH TO A DECENTRALIZED FUTURE
              </p>
            </div>
          </div>

          {getToken && (
            <div className="hidden lg:flex items-center gap-3">
              <button
                type="button"
                onClick={() => setOpenInfo(true)}
                className="flex h-10 items-center gap-2 rounded-xl border border-[#EE0000]/60 bg-gradient-red px-4 text-sm font-medium text-white shadow-[0_6px_20px_-8px_rgba(238,0,0,0.7)] transition-all hover:border-[#EE0000] hover:shadow-[0_8px_24px_-6px_rgba(238,0,0,0.9)]"
              >
                <span className="text-xl">{reactIcons?.support}</span>
                Customer Support
              </button>
              <button
                type="button"
                ref={notificationBellRef}
                aria-label="Notifications"
                onClick={() => {
                  setIsNotificationOpen((prev) => !prev);
                }}
                className={`portal-icon-btn text-xl ${isNotificationOpen ? "!border-[#EE0000]/60 !bg-[#EE0000]/15" : ""}`}
              >
                {reactIcons.notificationBold}
                {currentMessages.length > 0 && (
                  <span className="absolute -top-1.5 -right-1.5 flex h-5 min-w-[20px] items-center justify-center rounded-full bg-[#EE0000] px-1 text-10 font-bold text-white ring-2 ring-[#080808]">
                    {currentMessages.length > 99
                      ? "99+"
                      : currentMessages.length}
                  </span>
                )}
              </button>
              <div
                className="flex items-center gap-3 rounded-xl border border-white/10 bg-white/[0.04] py-1.5 pl-1.5 pr-4 cursor-pointer transition-colors hover:border-[#EE0000]/50 hover:bg-white/[0.07]"
                onClick={() => navigate("/portal/profile")}
              >
                <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-gradient-to-br from-[#EE0000] to-[#730000] text-white text-lg">
                  {reactIcons.user}
                </span>
                <div className="leading-tight">
                  <p className="text-white capitalize text-sm font-semibold max-w-[180px] truncate">
                    {userData?.firstname + " " + userData?.lastname ||
                      "N/A"}{" "}
                  </p>
                  <p className="text-[#ff4d4d] text-12 font-semibold">
                    {userData?.meta?.referredAs == "PowerFranchise" &&
                    !userData?.isClubUser
                      ? "Power Franchise"
                      : userData?.meta?.commissionPercentage >= 10 &&
                          userData?.meta?.commissionPercentage <= 14 &&
                          !userData?.isClubUser
                        ? "Spartans" //Distributor
                        : userData?.meta?.commissionPercentage >= 15 &&
                            userData?.meta?.commissionPercentage <= 19 &&
                            !userData?.isClubUser
                          ? "Spider" //Sub Franchise
                          : userData?.meta?.commissionPercentage >= 20 &&
                              !userData?.isClubUser
                            ? "Avengers" //Franchise
                            : userData?.isClubUser &&
                                userData?.currentClubLevel == 1
                              ? "Warriors"
                              : userData?.isClubUser &&
                                  userData?.currentClubLevel == 2
                                ? "Legends"
                                : userData?.currentClubLevel == 3
                                  ? "Super Legend"
                                  : "My Profile"}
                  </p>
                </div>
              </div>
            </div>
          )}

          <div className="flex items-center gap-2 lg:hidden">
            {getToken && (
              <button
                aria-label="Customer support"
                onClick={() => setOpenInfo(true)}
                className="portal-icon-btn text-2xl"
              >
                {reactIcons.support}
              </button>
            )}

            {getToken && (
              <button
                type="button"
                aria-label="Notifications"
                onClick={() => {
                  setIsNotificationOpen((prev) => !prev);
                }}
                className="portal-icon-btn text-xl"
              >
                {reactIcons.notificationBold}
                {currentMessages.length > 0 && (
                  <span className="absolute -top-1.5 -right-1.5 flex h-5 min-w-[20px] items-center justify-center rounded-full bg-[#EE0000] px-1 text-10 font-bold text-white ring-2 ring-[#080808]">
                    {currentMessages.length > 99
                      ? "99+"
                      : currentMessages.length}
                  </span>
                )}
              </button>
            )}
            <button
              aria-label="Toggle menu"
              data-sidebar-toggle
              onClick={toggleSidebar}
              className="portal-icon-btn text-2xl"
            >
              {reactIcons.toggle}
            </button>
          </div>
        </div>
      </div>
      {
        <InfoModal
          open={openInfo}
          setOpen={setOpenInfo}
          message={
            "NOTE : Please ensure you provide your registered email address, as the support system will not be able to assist you without it."
          }
          type={"two"}
        />
      }

      <NotificationPanel
        ref={notificationContainerRef}
        groupedNotifications={groupedNotifications}
        isNotificationOpen={isNotificationOpen}
      />
    </>
  );
};
export default Header;
